/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const Paths = {
  SAMPLE_APPLICATION: {
    ROOT: '/sample-application',
    OVERVIEW: '/sample-application/overview',
    FORM: '/sample-application/form',
    CONFIRMATION: '/sample-application/confirmation',
  },
  APPLY: '/apply',
  CHAP_APPLICATION: {
    APPLICATION_OVERVIEW: '/application-overview',
  },
  CHAP3_APPLICATION: {
    APPLICATION_OVERVIEW: '/chap3-application-overview',
  },
  PASSWORD_RESET: {
    FORM: '/forgot-password',
  },
  ENROLL_WAITLIST: {
    FORM: '/enroll-waitlist/form',
  },

  ACTIVATE_CITIZEN_ACCOUNT: '/activate-account',
  ACTIVATE_EMAIL: '/activate-email',
  EMAIL_PASSWORD_RESET: '/email-password-reset',
  FORGOT_PASSWORD_RESET: '/forgot-password-reset',
  FORGOT_USERNAME: '/forgot-username',
  ACCOUNT_UNLOCK: '/unlock-account',
  ACCOUNT_UNLOCK_EMAIL: '/account-unlock-email',
  HOME: '/',
  VERIFICATIONS: {
    ROOT: '/verifications',
    DETAILS: '/verifications/details',
  },
  DISCLAIMER: '/disclaimer',
  PRIVACY: '/privacy',
  PROFILE: '/profile',
};

export const ExtPaths = {
  // ATTESTATION_FORM: 'https://CHAPportal.clarkcountynv.gov/Impact_and_Attestation_Form.pdf'
  ATTESTATION_FORM: 'forms/Impact_and_Attestation_Form.pdf',
  CLARKCOUNTY_HOME: 'https://assistanceprogramsportal.clarkcountynv.gov/CE',
};

/**
 * Provides access the the URLs that are mapped to each page via the route configuration.
 */
export default Paths;
